// /js/tiptap.js
import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

import { Document } from './tiptap/Document'
import { Document as BaseDocument } from '@tiptap/extension-document'
import { ChartTemplate } from './tiptap/ChartTemplate'
import { ChartSection } from './tiptap/ChartSection'
import { SmartBlock } from './tiptap/SmartBlock'
import { FieldToken } from './tiptap/FieldToken'
import { PhraseToken } from './tiptap/PhraseToken'
import { ChartHeader } from './tiptap/ChartHeader'
import { ChartBanner } from './tiptap/ChartBanner'
import { ChartIntro } from './tiptap/ChartIntro'
import { ChartSignature } from './tiptap/ChartSignature'
import { ChartImagesSection } from './tiptap/ChartImagesSection'
import { ChartImage } from './tiptap/ChartImage'
import { ChartIntroRow } from './tiptap/ChartIntroRow'
import { NextPlaceholder } from './tiptap/NextPlaceholder'
import { InsertedFrom } from './tiptap/InsertedFrom'

// real, editable tables. The code tables in an authored document were resolved smart blocks -- atomic nodes a
// provider could read but not change -- so a diagnosis could not be removed from a draft without rewriting the
// whole block. chart::render_node() renders these too, or signing would refuse a document containing one.
import { Table, TableRow, TableCell, TableHeader } from '@tiptap/extension-table'

import Heading from '@tiptap/extension-heading'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import Blockquote from '@tiptap/extension-blockquote'
import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Text } from '@tiptap/extension-text'
import Underline from '@tiptap/extension-underline'



const REMOVED_SECTION_CACHE = {}


/*
const editor = new Editor({
  element: document.querySelector('#tiptap_editor'),

  extensions: [
    Document,
    StarterKit.configure({ document: false }),
    ChartTemplate,
    ChartSection,
    SmartBlock, 
		FieldToken,
		PhraseToken,
		ChartHeader,
		ChartIntro,
		ChartSignature,
		ChartImagesSection,
		ChartImage,
		ChartIntroRow,
		NextPlaceholder,
		InsertedFrom,
  ],
})
*/


/*
function createChartEditor(element) {
  return new Editor({
    element,

    editable: window.CHART_MODE === 'edit',

    extensions: [
      Document,
      StarterKit.configure({ document: false }),
      ChartTemplate,
      ChartSection,
      SmartBlock,
      FieldToken,
      PhraseToken,
      ChartHeader,
      ChartIntro,
      ChartSignature,
      ChartImagesSection,
      ChartImage,
      ChartIntroRow,
      NextPlaceholder,
      InsertedFrom,
    ],

    onCreate({ editor }) {
      // DISPLAY MODE
			if (window.CHART_MODE === 'display') {
				editor.commands.setContent(window.CHART_TEMPLATE);
				//editor.setEditable(false);
				editor.setEditable(true);

				// wait one tick for DOM to exist
				setTimeout(() => {
					resolveFieldTokensInDOM(window.CHART_CONTEXT);
				}, 0);

				return;
			}

			// AUTHOR MODE
			if (window.CHART_MODE === 'edit') {
				const template = clone(CHART_TEMPLATE_SCAFFOLD);
				template.attrs.encounter_id = window.ENCOUNTER_ID ?? null;

				editor.commands.setContent(template);
			}
    },
  });
}
*/

function createChartEditor(element, single_input_array)
{
  var editor_mode = single_input_array['mode'] || 'edit';           // 'edit' | 'display'
  var chart_template = single_input_array['template'] || null;      // TipTap JSON (chart doc OR chart_template)
  var encounter_id = single_input_array['encounter_id'] || null;
  var chart_context = single_input_array['context'] || {};          // field map for display resolution (optional)

	var editor_id = single_input_array['editor_id'];

  console.log("got here to createChartEditor");
  console.log(single_input_array);

	var wrapper = element.closest('.chart_editor_wrapper');
	if (wrapper && editor_id) {
		wrapper.setAttribute('data-editor-id', editor_id);
	}

	

  return new Editor({
    element,

    editable: (editor_mode === 'edit'),

    extensions: [
      Document,
      StarterKit.configure({ document: false }),
      ChartTemplate,
      ChartSection,
      SmartBlock,
      FieldToken,
      PhraseToken,
      ChartHeader,
      ChartBanner,
      ChartIntro,
      ChartSignature,
      ChartImagesSection,
      ChartImage,
      ChartIntroRow,
      NextPlaceholder,
      InsertedFrom,
      Table.configure({ resizable: false }),
      TableRow,
      TableHeader,
      TableCell,
    ],

    onCreate({ editor }) {

      // ✅ MAKE EDITOR AVAILABLE TO DOTPHRASE CODE
      window.chart_editor = editor;

      // store instance-specific state (no globals)
			editor.storage.editor_id = single_input_array['editor_id'];
      editor.storage.chart_id = single_input_array['chart_id'];
      editor.storage.editor_context = 'chart';
      editor.storage.editor_mode = editor_mode;
      editor.storage.field_context = chart_context;
      // the stored draft revision this editor was loaded from (CMR-2026-10-06-216). Every save and Sign sends it;
      // the server refuses a save from an editor that has not seen a newer revision, e.g. an AI note applied
      // by the scribe worker while this note was open
      editor.storage.draft_version = parseInt(element.getAttribute('draft_version') || '0', 10) || 0;
      editor.storage.save_blocked = false;
      editor.storage.flush_waiters = [];
      editor.storage.last_save_ok = true;

      // DISPLAY MODE
      if(editor_mode === 'display') 
			{
        console.log("create display chart");
        if(chart_template) {
          editor.commands.setContent(chart_template);
        }
        editor.setEditable(false);

        /*
        editor.on('transaction', ({ transaction }) => {
          if (transaction.docChanged) {
            console.warn('Blocked mutation on signed chart');
            transaction.steps.length = 0;
          }
        });

				ChartEditor.updateNavigationButtons(editor);
				installRequiredOverwriteHandler(editor);

				setTimeout(() => {
					markRequiredFields(editor);
				}, 0);

        // scope resolve to THIS editor only
        setTimeout(() => {
          resolveFieldTokensInDOM(chart_context, element);
        }, 0);
        */

        return;
      }

      // EDIT MODE
      if(editor_mode === 'edit') 
      {

        console.log("create edit chart");

        if (chart_template) {
          // if you passed in a template/doc, use it
          editor.commands.setContent(chart_template);
          return;
        }

        // default scaffold
        const template = clone(CHART_TEMPLATE_SCAFFOLD);
        //template.attrs.encounter_id = encounter_id;

        editor.commands.setContent(template);

        // 🔑 hide default-hidden sections
        removeHiddenByDefaultSections(editor)
      }

      if(window.chart_table_tools_refresh)
        window.chart_table_tools_refresh(editor)
    },

    // the table tools appear when the note holds a table, so the control is visible before the cursor is in one
    onSelectionUpdate({ editor })
    {
      if(window.chart_table_tools_refresh)
        window.chart_table_tools_refresh(editor)
    },

		onUpdate({ editor }) 
		{
			ChartEditor.updateNavigationButtons(editor);
      autosave_chart(editor);

      if(window.chart_table_tools_refresh)
        window.chart_table_tools_refresh(editor)
		},

		onFocus({ editor }) {
			window.ChartEditor.active_editor_id = editor.storage.editor_id;
		},
  });
}

// autosave state lives on each editor, so two open notes never share a timer, and saves for one note run one
// at a time: a slow earlier save can no longer land after a newer one and overwrite it
function autosave_chart(editor)
{
  if(editor.storage.editor_mode !== 'edit' || !editor.storage.chart_id)
    return;

  clearTimeout(editor.storage.autosave_timer);
  editor.storage.autosave_timer = setTimeout(() => { editor.storage.autosave_timer = null; autosave_chart_send(editor); }, 800);
}

function autosave_chart_send(editor)
{
  // after a conflict the editor stops saving and keeps its text until the provider loads the newer note
  if(editor.storage.save_blocked)
  {
    autosave_chart_settle(editor, false);
    return;
  }
  if(editor.storage.autosave_in_flight)
  {
    editor.storage.autosave_dirty = true;
    return;
  }
  editor.storage.autosave_in_flight = true;
  editor.storage.autosave_dirty = false;

  var single_input_array = {};
  single_input_array['chart_id'] = editor.storage.chart_id;
  single_input_array['draft_content'] = JSON.stringify(editor.getJSON());
  single_input_array['draft_version'] = String(editor.storage.draft_version || 0);

  $.post('shared_ajax_functions5.php', { dowhat: 'autosave_chart_draft', single_input_array: single_input_array })
    .done(function(data)
    {
      var json = null;
      try { json = $.parseJSON(data); } catch(e) {}
      if(json && json.type === 'success')
      {
        if(json.draft_version)
          editor.storage.draft_version = parseInt(json.draft_version, 10);
        editor.storage.last_save_ok = true;
        autosave_chart_status(editor, '');
        return;
      }
      editor.storage.last_save_ok = false;
      if(json && (json.type === 'conflict' || json.type === 'refresh_required'))
      {
        // never overwrite the newer stored note; the text on screen stays in memory (not in browser storage)
        editor.storage.save_blocked = true;
        editor.storage.autosave_dirty = false;
        if(typeof window.scribe_on_draft_conflict === 'function')
          window.scribe_on_draft_conflict(editor, json);
        else
          autosave_chart_status(editor, json.display || 'This note was changed elsewhere. Close and reopen it to see the latest version.');
        return;
      }
      autosave_chart_status(editor, json && json.type === 'error' ? json.display : '');
    })
    .fail(function()
    {
      editor.storage.last_save_ok = false;
      autosave_chart_status(editor, 'Your latest changes could not be saved. Check your connection; they will be included when you sign.');
    })
    .always(function()
    {
      editor.storage.autosave_in_flight = false;
      if(editor.storage.autosave_dirty && !editor.storage.save_blocked)
        autosave_chart_send(editor);
      else
        autosave_chart_settle(editor, editor.storage.last_save_ok && !editor.storage.save_blocked);
    });
}

// resolve everyone waiting on a flush once no save is pending or in flight
function autosave_chart_settle(editor, ok)
{
  var waiters = editor.storage.flush_waiters || [];
  editor.storage.flush_waiters = [];
  waiters.forEach(function(resolve) { resolve({ ok: ok, draft_version: editor.storage.draft_version }); });
}

function autosave_chart_status(editor, message)
{
  var wrapper = editor.options.element ? editor.options.element.closest('.chart_editor_wrapper') : null;
  var holder = wrapper ? wrapper.parentNode : null;
  var box = holder ? holder.querySelector('.chart_autosave_errors') : null;

  if(!message)
  {
    if(box) $(box).fadeOut();
    return;
  }
  if(box)
    $(box).hide().html(message).fadeIn();
  else if(typeof showToast === 'function')
    showToast(message, 'error');
}


function createBlogEditor(element, single_input_array)
{
  var editor_mode    = single_input_array['mode'] || 'edit';
  var content        = single_input_array['content'] || null;
  var editor_id      = single_input_array['editor_id'];
  var editor_context = single_input_array['editor_context'] || 'blog';

  return new Editor({
    element,

    editable: (editor_mode === 'edit'),

    extensions: [
      BaseDocument,
      StarterKit.configure({ document: false, heading: false, blockquote: false }),
      Heading.configure({ levels: [1, 2, 3] }),
      Blockquote,
      Image,
      Link.configure({ openOnClick: false }),
    ],

    onCreate({ editor })
    {
      editor.storage.editor_id      = editor_id;
      editor.storage.editor_context = editor_context;

      if(content)
      {
        editor.commands.setContent(content);
      }
      else if(editor_mode === 'edit')
      {
        editor.commands.setContent({
          type: 'doc',
          content: [
            { type: 'paragraph', content: [{ type: 'text', text: 'Start writing here…' }] }
          ]
        });
      }

      if(editor_mode === 'display')
        editor.setEditable(false);
    },
  });
}

function createStandardTextEditor(element, single_input_array)
{
  const editor_mode = single_input_array['mode'] || 'edit';
  const content = single_input_array['content'] || null;

  const wrapper = element.closest('.chart_editor_wrapper');
  const toolbarElement = wrapper
    ? wrapper.querySelector('.editor_toolbar')
    : null;

  const editor = new Editor({
    element,

    editable: editor_mode === 'edit',

    extensions: [
      StarterKit,   // Document, Paragraph, Lists, Bold, Italic, etc
      FieldToken,   // keep this if you want {field} support
    ],

    content: content || {
      type: 'doc',
      content: [
        { type: 'paragraph' }
      ]
    },

    onCreate({ editor }) 
    {
      editor.storage.editor_context = 'quickphrase';
      editor.storage.editor_mode = editor_mode;

      if (editor_mode === 'display') {
        editor.setEditable(false);
      }
    },
  });

  if (toolbarElement && editor_mode === 'edit') {
    setupStandardToolbar(editor, toolbarElement);
  }

  return editor;
}


function setupStandardToolbar(editor, toolbar)
{
  // Button clicks
  $(toolbar).on('click', function(e)
  {
    const action = e.target.closest('[data-action]')?.dataset.action;
    if (!action) return;

    e.preventDefault();

    switch (action)
    {
      case 'bold':
        editor.chain().focus().toggleBold().run();
        break;

      case 'italic':
        editor.chain().focus().toggleItalic().run();
        break;

      case 'underline':
        editor.chain().focus().toggleUnderline().run();
        break;

      case 'bullet':
        editor.chain().focus().toggleBulletList().run();
        break;

      case 'ordered':
        editor.chain().focus().toggleOrderedList().run();
        break;
    }
  });

  // Heading dropdown
  const headingSelect = toolbar.querySelector('[data-action="heading"]');
  if (headingSelect)
  {
    headingSelect.addEventListener('change', function(e)
    {
      const level = parseInt(e.target.value);

      if (!level) {
        editor.chain().focus().setParagraph().run();
      } else {
        editor.chain().focus().toggleHeading({ level }).run();
      }
    });
  }
}


$(document).on('click', '#bold_btn', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  editor.chain().focus().toggleBold().run();
});


$(document).on('click', '#add_section_button', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  if (
    editor.storage.editor_context !== 'blog' &&
    editor.storage.editor_context !== 'help'
  ) {
    return;
  }

  const { state } = editor;
  const insertPos = state.selection.to;

  editor
    .chain()
    .focus()
    .insertContentAt(insertPos, [
      {
        type: 'heading',
        attrs: { level: 2 },
        content: [{ type: 'text', text: 'New Section' }]
      },
      { type: 'paragraph' }
    ])
    .setTextSelection(insertPos + 2)
    .run();
});


$(document).on('click', '#insert_image_button', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  // gate by editor instance, not global
  if (
    editor.storage.editor_context !== 'blog' &&
    editor.storage.editor_context !== 'help'
  ) {
    return;
  }

  const url = prompt('Enter image URL');
  if (!url) return;

  editor
    .chain()
    .focus()
    .setImage({ src: url })
    .run();
});


$(document).on('click', '#insert_link_button', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
	if (!editor) return;

	if (
		editor.storage.editor_context !== 'blog' &&
		editor.storage.editor_context !== 'help'
	) {
		return;
	}


  const previousUrl = editor.getAttributes('link').href;
  const url = prompt('Enter URL', previousUrl || '');

  if (url === null)
    return;

  // Remove link if URL is empty
  if (url === '') {
    editor
      .chain()
      .focus()
      .extendMarkRange('link')
      .unsetLink()
      .run();
    return;
  }

  editor
    .chain()
    .focus()
    .extendMarkRange('link')
    .setLink({ href: url })
    .run();
});


const QUICKPHRASE_TEMPLATE = {
  type: 'chart_template',
  attrs: { encounter_id: null },
  content: [
   {
      type: 'chart_section',
      attrs: { section_type: 'quickphrase' },
      content: [
				{ type: 'paragraph' },
      ],
    },
  ],
};


const CHART_TEMPLATE_SCAFFOLD = {
  type: 'chart_template',
  attrs: { encounter_id: null },
  content: [
    /*{ type: 'chart_header' },*/

    // NOTE:
    // chart_banner is NOT here.
    // It is injected server-side during instantiate()
    
    /*
    {
  type: 'chart_intro',
  content: [
    {
      type: 'chart_intro_row',
      attrs: { label: 'Patient Name' },
      content: [{ type: 'field_token', attrs: { field: 'patient_name', label: 'Patient Name' } }],
    },
    {
      type: 'chart_intro_row',
      attrs: { label: 'DOB' },
      content: [{ type: 'field_token', attrs: { field: 'patient_dob', label: 'Patient DOB' } }],
    },
    {
      type: 'chart_intro_row',
      attrs: { label: 'MRN' },
      content: [{ type: 'field_token', attrs: { field: 'patient_mrn', label: 'Patient MRN' } }],
    },
    {
      type: 'chart_intro_row',
      attrs: { label: 'Visit Date' },
      content: [{ type: 'field_token', attrs: { field: 'visit_date', label: 'Visit Date' } }],
    },
    {
      type: 'chart_intro_row',
      attrs: { label: 'Provider' },
      content: [{ type: 'field_token', attrs: { field: 'provider_name', label: 'Provider Name' } }],
    },
    {
      type: 'chart_intro_row',
      attrs: { label: 'Visit Format' },
      content: [{ type: 'field_token', attrs: { field: 'visit_format', label: 'Visit Format' } }],
    },
  ],
},
*/
    { type: 'chart_section', attrs: { section_type: 'cc' }, content: [{ type: 'smart_block', attrs: { key: 'cc' } }, { type: 'paragraph' }] },
    {
      type: 'chart_section',
      attrs: { section_type: 'hpi' },
      content: [
        {
          type: 'paragraph',
          content: [
            { type: 'field_token', attrs: { field: 'patient_name', label: 'Patient Name' } },
            { type: 'text', text: ' is a ' },
            { type: 'field_token', attrs: { field: 'patient_age', label: 'Patient Age' } },
            { type: 'text', text: ' year old ' },
            { type: 'field_token', attrs: { field: 'patient_gender', label: 'Patient Gender' } },
            { type: 'text', text: ' presenting today with complaints of ***' },
          ],
        },
        { type: 'paragraph' }, // second empty paragraph so cursor feels natural
      ],
    },

    { type: 'chart_section', attrs: { section_type: 'ros' }, content: [emptyParagraph()] },
		{ type: 'chart_section', attrs: { section_type: 'pmh' }, content: [{ type: 'smart_block', attrs: { key: 'medical_history' } }, { type: 'paragraph' }]},
		{ type: 'chart_section', attrs: { section_type: 'psh' }, content: [{ type: 'smart_block', attrs: { key: 'surgical_history' } }, { type: 'paragraph' }]},
		{ type: 'chart_section', attrs: { section_type: 'fh' }, content: [{ type: 'smart_block', attrs: { key: 'family_history' } }, { type: 'paragraph' }]},
		{ type: 'chart_section', attrs: { section_type: 'sh' }, content: [{ type: 'smart_block', attrs: { key: 'social_history' } }, { type: 'paragraph' }]},
		{
			"type": "chart_section",
			"attrs": {
				"section_type": "gyn",
				"visible_if": {
					"field": "patient_gender",
					"equals": "female"
				}
			},
			"content": [
				{
					"type": "smart_block",
					"attrs": { "key": "gynecologic_history" }
				},
				{ "type": "paragraph" }
			]
		},
		{ type: 'chart_section', attrs: { section_type: 'meds' }, content: [{ type: 'smart_block', attrs: { key: 'meds' } }, { type: 'paragraph' }]},
		{ type: 'chart_section', attrs: { section_type: 'allergies' }, content: [{ type: 'smart_block', attrs: { key: 'allergies' } }, { type: 'paragraph' }]},
		{ type: 'chart_section', attrs: { section_type: 'immunizations' }, content: [{ type: 'smart_block', attrs: { key: 'immunizations' } }, { type: 'paragraph' }]},
    { 
      type: 'chart_section',
      attrs: { section_type: 'pe' },
      content: [
        { type: 'smart_block', attrs: { key: 'vitals' } },
        emptyParagraph()
      ]
    },
    { type: 'chart_section', attrs: { section_type: 'procedure', hidden_by_default: true }, content: [emptyParagraph()]  },
		{
			type: 'chart_section',
			attrs: { section_type: 'mdm' },
			content: [
				{
					type: 'paragraph',
					content: [
						{ type: 'field_token', attrs: { field: 'patient_name', label: 'Patient Name' } },
						{ type: 'text', text: ' is a ' },
						{ type: 'field_token', attrs: { field: 'patient_age', label: 'Patient Age' } },
						{ type: 'text', text: ' year old ' },
						{ type: 'field_token', attrs: { field: 'patient_gender', label: 'Patient Gender' } },
						{ type: 'text', text: ' presenting today with complaints of '},
						{ type: 'field_token', attrs: { field: '***', label: '***' } },
					]
				},
				{ type: 'paragraph' } // second empty paragraph so cursor feels natural
			]
		},
		{ type: 'chart_section', attrs: { section_type: 'a_p' }, content: [emptyParagraph()] },
		{ type: 'chart_section', attrs: { section_type: 'impression' }, content: [emptyParagraph()]  },
		{ type: 'chart_section', attrs: { section_type: 'disposition' }, content: [emptyParagraph()]  },

		{ type: 'chart_section', attrs: { section_type: 'subjective', hidden_by_default: true }, content: [emptyParagraph()]  },
		{ type: 'chart_section', attrs: { section_type: 'objective', hidden_by_default: true }, content: [emptyParagraph()]  },
		{ type: 'chart_section', attrs: { section_type: 'assessment', hidden_by_default: true }, content: [emptyParagraph()]  },
		{ type: 'chart_section', attrs: { section_type: 'plan', hidden_by_default: true }, content: [emptyParagraph()]  },
  ],
};



function emptyParagraph() {
  return { type: 'paragraph', content: [] };
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}


/*
editor.on('create', () => {

  // DISPLAY MODE
	if (window.CHART_MODE === 'display') {
    editor.commands.setContent(window.CHART_TEMPLATE);
    //editor.setEditable(false);
		editor.setEditable(true);

    // wait one tick for DOM to exist
    setTimeout(() => {
      resolveFieldTokensInDOM(window.CHART_CONTEXT);
    }, 0);

    return;
  }

  // AUTHOR MODE
  if (window.CHART_MODE === 'edit') {
    const template = clone(CHART_TEMPLATE_SCAFFOLD);
    template.attrs.encounter_id = window.ENCOUNTER_ID ?? null;

    editor.commands.setContent(template);
  }

});
*/
	




function resolveSmartBlocks(editor, dataMap) {
  const { state, view } = editor
  const tr = state.tr

  state.doc.descendants((node, pos) => {
    if (node.type.name === 'smart_block' && !node.attrs.resolved) {
      const snapshot = dataMap[node.attrs.key]

      if (snapshot) {
        tr.setNodeMarkup(pos, null, {
          ...node.attrs,
          snapshot,
          resolved: true,
        })
      }
    }
  })

  if (tr.steps.length) {
    view.dispatch(tr)
  }
}

$(document).on('click', '.chart_quickblock', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  var quickblock_key = $(this).attr('data-key');
  if (!quickblock_key) return;

  editor
    .chain()
    .focus()
    .insertContent([
      { type: 'smart_block', attrs: { key: quickblock_key } },
      { type: 'paragraph' }
    ])
    .run();
});


function sectionHasQuickBlock(editor, key)
{
  var found = false;

  editor.state.doc.nodesBetween(
    editor.state.selection.from,
    editor.state.selection.to,
    function(node)
    {
      if(node.type.name === 'smart_block' && node.attrs.key === key)
        found = true;
    }
  );

  return found;
}


/* creates {FIELD} that will map to database field for patient/chart */
/* creates {FIELD} that will map to database field for patient/chart */
$(document).on('click', '.chart_field_insert', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  var field_key = $(this).attr('data-field');
  if (!field_key) return;

  var display_label = field_key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, function(l){ return l.toUpperCase(); });

  // 🔑 ENSURE WE ARE IN A TEXTBLOCK
  var state = editor.state;
  var $from = state.selection.$from;

  if (!$from.parent.isTextblock)
  {
    // create a paragraph and move cursor into it
    editor
      .chain()
      .focus()
      .insertContent({ type: 'paragraph' })
      .run();
  }

  editor
    .chain()
    .focus()
    .insertContent({
      type: 'field_token',
      attrs: {
        field: field_key,
        label: display_label,
      }
    })
    .run();
});




$(document).on('keydown', function(e)
{
  if(e.key !== 'Backspace' && e.key !== 'Delete')
    return;

  const sel = window.getSelection();
  if(!sel || sel.rangeCount === 0)
    return;

  const range = sel.getRangeAt(0);
  let node = range.startContainer;

  if(node.nodeType === Node.TEXT_NODE)
    node = node.parentNode;

  if(!node)
    return;

  // If cursor is inside or adjacent to a field token
  const token = node.closest('.chart_field_token');

  if(token)
  {
    e.preventDefault();
    token.remove();
  }
});

$(document).on('keydown', function(e)
{
  if(e.key !== 'Tab')
    return;

  // Only intercept Tab when focus is inside a tiptap editor
  var focused = document.activeElement;
  if(!focused || !focused.closest('.ProseMirror'))
    return;

  var editor = ChartEditor.get(ChartEditor.active_editor_id);
  if(!editor)
    return;

  var spots = getRequiredSpots(editor);
  if(!spots.length)
    return;

  e.preventDefault();
  jumpRequired(editor, 'next');
});


$(document).on('click', '.chart_phrase_insert', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this);
  if (!editor) return;

  var phrase_key = $(this).attr('data-phrase');
  if (!phrase_key) return;

  editor
    .chain()
    .focus()
    .insertContent({
      type: 'phrase_token',
      attrs: {
        phrase: phrase_key,
        label: '.' + phrase_key,
      }
    })
    .run();
});



/*
$(document).on('click', '.chart_phrase_insert', function(e)
{
  e.preventDefault();

  var phrase_key = $(this).attr('data-phrase');
  if(!phrase_key)
    return;

  editor
    .chain()
    .focus()
    .insertContent({
      type: 'phrase_token',
      attrs: {
        phrase: phrase_key,
        label: '.' + phrase_key,
      }
    })
    .run();
});
*/


function applySignature(editor, provider) {
  const { state, view } = editor
  const tr = state.tr

  state.doc.descendants((node, pos) => {
    if (node.type.name === 'chart_signature') {
      tr.setNodeMarkup(pos, null, {
        provider_name: provider.name,
        credentials: provider.credentials,
        specialty: provider.specialty,
        signed_at: provider.signed_at,
        signature_url: provider.signature_url,
      })
    }
  })

  view.dispatch(tr)
}



const SECTION_ORDER = [
  'cc', 
  'hpi',
  'ros',
  'pmh',
  'psh',
  'fh',
  'sh',
  'gyn',
  'meds',
  'allergies',
  'immunizations',
  'pe',
  'procedure',
  'mdm',
  'a_p',
  'impression',
  'disposition',
  'subjective',
  'objective',
  'assessment',
  'plan',
]


function hasSection(editor, sectionType) {
  let found = false

  editor.state.doc.descendants(node => {
    if (node.type.name === 'chart_section' && node.attrs.section_type === sectionType) {
      found = true
    }
  })

  return found
}

function insertSection(editor, sectionType) {
  if (hasSection(editor, sectionType)) return

  const insertPos = findSectionInsertPos(editor, sectionType)

  const sectionNode =
    REMOVED_SECTION_CACHE[sectionType] || {
      type: 'chart_section',
      attrs: { section_type: sectionType },
      content: [{ type: 'paragraph' }],
    }

  editor
    .chain()
    .insertContentAt(insertPos, sectionNode)
    .run()
}




function removeSection(editor, sectionType) {
  const { state, view } = editor
  const tr = state.tr

  let sectionPositions = []
  let sectionCount = 0

  state.doc.descendants((node, pos) => {
    if (node.type.name === 'chart_template') {
      sectionCount = node.content.content.filter(
        n => n.type.name === 'chart_section'
      ).length
    }

    if (node.type.name === 'chart_section' && node.attrs.section_type === sectionType) {
      // ✅ Cache removed content
      REMOVED_SECTION_CACHE[sectionType] = node.toJSON()

      sectionPositions.push({
        pos,
        size: node.nodeSize,
      })
    }
  })

  // 🔒 Enforce chart_section+
  if (sectionCount - sectionPositions.length < 1) {
    console.warn('Cannot remove last chart section')
    return
  }

  // Delete bottom → top to avoid position shifting
  sectionPositions
    .sort((a, b) => b.pos - a.pos)
    .forEach(({ pos, size }) => {
      tr.delete(pos, pos + size)
    })

  if (tr.steps.length) {
    view.dispatch(tr)
  }
}


function findSectionInsertPos(editor, sectionType) {
  const { doc } = editor.state
  const targetIndex = SECTION_ORDER.indexOf(sectionType)

  let insertPos = null
  let templateEndPos = null
  let signaturePos = null

  doc.descendants((node, pos) => {
    if (node.type.name === 'chart_template') {
      templateEndPos = pos + node.nodeSize - 1 // inside template
    }

    if (node.type.name === 'chart_signature') {
      signaturePos = pos
    }

    if (node.type.name === 'chart_section') {
      const idx = SECTION_ORDER.indexOf(node.attrs.section_type)

      if (idx > targetIndex && insertPos === null) {
        insertPos = pos
      }
    }
  })

  // Insert before the next section in order
  if (insertPos !== null) {
    return insertPos
  }

  // Insert before signature if it exists
  if (signaturePos !== null) {
    return signaturePos
  }

  // 🔑 Insert at end of chart_template (NOT doc)
  return templateEndPos
}




$(document).on('click', '.chart_section_toggle', function(e)
{
  e.stopPropagation();   // 🔑 prevent dropdown from stealing the click

  const sectionType = $(this).data('section');
  const checked = $(this).is(':checked');

	var editor = getEditorFromToolbarElement(this);
	if (!editor) return;

	if (checked) {
		insertSection(editor, sectionType);
	} else {
		removeSection(editor, sectionType);
	}
});


// ------------------------------------
// Resolve fields ex. {name} ==> NAME
// ------------------------------------
/*
function resolveFieldTokensInDOM(context) {
  document.querySelectorAll('field-token').forEach(node => {
    const field = node.getAttribute('data-field');
    if (!field) return;

    if (context[field] !== undefined) {
      node.textContent = context[field];
      node.classList.add('chart_field_resolved');
    }
  });
}
	*/

function resolveFieldTokensInDOM(context, root_element)
{
  var root = root_element || document;

  root.querySelectorAll('field-token').forEach(node => {
    const field = node.getAttribute('data-field');
    if (!field) return;

    if (context[field] !== undefined) {
      node.textContent = context[field];
      node.classList.add('chart_field_resolved');
    }
  });
}



// ------------------------------------
// DEBUG
// ------------------------------------
//document.getElementById('dump_content').addEventListener('click', function(e)
$(document).on('click', '#dump_content', function(e)
{
  e.preventDefault();

  var editor = getEditorFromToolbarElement(this)
		|| ChartEditor.get(ChartEditor.active_editor_id);

	if (!editor) {
		console.warn('Editor not initialized');
		return;
	}

  console.log(editor.getJSON());
});

$(document).on('click', '.editor_toolbar_button', function(e)
{
  const listType = $(this).data('list');

  if (!listType)
    return;

  var editor = getEditorFromToolbarElement(this);
	if (!editor) return;

	if (
		editor.storage.editor_context !== 'blog' &&
		editor.storage.editor_context !== 'help'
	) {
		return;
	}

  e.preventDefault();

  editor.chain().focus();

  if (listType === 'bullet') {
    editor.chain().toggleBulletList().run();
  }

  if (listType === 'ordered') {
    editor.chain().toggleOrderedList().run();
  }
});




$(document).on('click', '.editor_toolbar_button', function(e)
{
  const blockType = $(this).data('block');

  if (blockType !== 'blockquote')
    return;

  var editor = getEditorFromToolbarElement(this);
	if (!editor) return;

	if (
		editor.storage.editor_context !== 'blog' &&
		editor.storage.editor_context !== 'help'
	) {
		return;
	}

  e.preventDefault();

  editor
    .chain()
    .focus()
    .toggleBlockquote()
    .run();
});






window.ChartEditor = {
  instances: {},

  create: function(single_input_array)
  {
    var editor_id = single_input_array['editor_id'];
    var selector = single_input_array['selector'];
    var editor_context = single_input_array['editor_context']; // 'chart' | 'blog' | 'help' | 'template'

    console.log("HERE ------->>>>", editor_id, selector, editor_context); 

    if(!editor_id || !selector)
    {
      console.warn('ChartEditor.create missing editor_id or selector');
      return null;
    }

    var element = document.querySelector(selector);

    if(!element)
    {
      console.warn('ChartEditor.create element not found:', selector);
      return null;
    }

    //destroy existing instance with same id
    if(this.instances[editor_id])
    {
      clearTimeout(this.instances[editor_id].storage.autosave_timer);
      this.instances[editor_id].destroy();
      delete this.instances[editor_id];
    }

    var editor = null;

    // treat template as chart editor too (same node set)
    if(editor_context === 'chart' || editor_context === 'template')
    {
      editor = createChartEditor(element, single_input_array);
    }
    else if(editor_context === 'blog' || editor_context === 'help')
    {
      editor = createBlogEditor(element, single_input_array);
    }
		else if(editor_context == 'quickphrase')
		{
			editor = createStandardTextEditor(element, single_input_array);
		}
    else
    {
      console.warn('Unknown editor_context:', editor_context);
      return null;
    }

    this.instances[editor_id] = editor;

    return editor;
  },

  get: function(editor_id)
  {
    return this.instances[editor_id] || null;
  },

  destroy: function(editor_id)
  {
    if(!this.instances[editor_id]) return;

    clearTimeout(this.instances[editor_id].storage.autosave_timer);
    this.instances[editor_id].destroy();
    delete this.instances[editor_id];
  },

  set_mode: function(single_input_array)
  {
    var editor_id = single_input_array['editor_id'];
    var mode = single_input_array['mode']; // 'edit' | 'display'

    var editor = this.get(editor_id);
    if(!editor) return;

    editor.storage.editor_mode = mode;
    editor.setEditable(mode === 'edit');
  },
};

window.getEditorFromToolbarElement = function (el)
{
  var wrapper = el.closest('.chart_editor_wrapper');
  if (!wrapper) return null;

  var editor_id = wrapper.getAttribute('data-editor-id');
  if (!editor_id) return null;

  return window.ChartEditor.get(editor_id);
};

/*
function getEditorFromToolbarElement(el)
{
  var wrapper = el.closest('.chart_editor_wrapper');
  if (!wrapper) return null;

  var editor_id = wrapper.getAttribute('data-editor-id');
  if (!editor_id) return null;

  return window.ChartEditor.get(editor_id);
}
*/

// the note being signed is the one on screen: stop any pending autosave and hand back the editor's own content
// the edit-mode editor holding this chart, if one is open
window.ChartEditor.editor_for_chart = function(chart_id)
{
  for(var editor_id in this.instances)
  {
    var editor = this.instances[editor_id];
    if(editor && editor.storage.editor_mode === 'edit' && String(editor.storage.chart_id) === String(chart_id))
      return editor;
  }
  return null;
};

// FLUSH: save anything pending for this chart now and resolve when the save has landed. Used before an AI dictation
// is uploaded (so the worker builds from what is on screen) and before Sign. Resolves {ok, draft_version}.
window.ChartEditor.flush_for_chart = function(chart_id)
{
  var editor = this.editor_for_chart(chart_id);
  if(!editor)
    return Promise.resolve({ ok: true, draft_version: 0 });
  return new Promise(function(resolve)
  {
    editor.storage.flush_waiters = editor.storage.flush_waiters || [];
    editor.storage.flush_waiters.push(resolve);
    var pending = !!editor.storage.autosave_timer;
    clearTimeout(editor.storage.autosave_timer);
    editor.storage.autosave_timer = null;
    if(editor.storage.save_blocked)
      autosave_chart_settle(editor, false);
    else if(editor.storage.autosave_in_flight)
      editor.storage.autosave_dirty = editor.storage.autosave_dirty || pending;
    else if(pending)
      autosave_chart_send(editor);
    else
      autosave_chart_settle(editor, editor.storage.last_save_ok !== false);
  });
};

window.ChartEditor.draft_version_for = function(chart_id)
{
  var editor = this.editor_for_chart(chart_id);
  return editor ? (editor.storage.draft_version || 0) : 0;
};

// LOAD A NEWER STORED NOTE into the open editor (after an AI note landed). Does not trigger a save; the editor
// adopts the loaded revision and resumes autosaving.
window.ChartEditor.load_latest = function(chart_id, doc, draft_version)
{
  var editor = this.editor_for_chart(chart_id);
  if(!editor)
    return false;
  clearTimeout(editor.storage.autosave_timer);
  editor.storage.autosave_timer = null;
  editor.commands.setContent(doc, { emitUpdate: false });
  editor.storage.draft_version = parseInt(draft_version, 10) || 0;
  editor.storage.save_blocked = false;
  editor.storage.autosave_dirty = false;
  editor.storage.last_save_ok = true;
  autosave_chart_status(editor, '');
  return true;
};

window.ChartEditor.content_for_signing = function(chart_id)
{
  for(var editor_id in this.instances)
  {
    var editor = this.instances[editor_id];
    if(editor && editor.storage.editor_mode === 'edit' && String(editor.storage.chart_id) === String(chart_id))
    {
      clearTimeout(editor.storage.autosave_timer);
      return JSON.stringify(editor.getJSON());
    }
  }
  return null;
};

window.ChartEditor.hasUnresolvedRequiredFields = function (editor) {
  if (!editor) return false;

  const root = editor.view.dom;
  return root.querySelectorAll(
    'field-token[data-field="***"]:not(.chart_field_resolved)'
  ).length > 0;
};

window.ChartEditor.updateNavigationButtons = function (editor)
{
  if (!editor) return;

  var remaining = getRequiredSpots(editor).length;

  var $nav = $(editor.view.dom).closest('.chart_editor_wrapper').find('.navigation_buttons');

  $nav.find('.prev_spot_thing, .next_spot_thing')
    .prop('disabled', remaining === 0);
};



function markRequiredFields(editor)
{
  if (!editor) return;

  const root = editor.view.dom;

  root.querySelectorAll('field-token').forEach(node => {
    if (node.getAttribute('data-field') === '***') {
      node.classList.add('chart_required_field');
    }
  });
}

function highlightAndScroll(editor, pos)
{
  const dom = editor.view.nodeDOM(pos);
  if (!dom) return;

  clearResolvedRequired(editor);

  dom.classList.add('chart_required_active');

  scrollEditorContainerToNode(editor, dom);

  // Select node so typing replaces it
  setTimeout(() => {
    editor.commands.setNodeSelection(pos);
  }, 120);
}



function clearResolvedRequired(editor)
{
  const root = editor.view.dom;

  root.querySelectorAll('.chart_required_active').forEach(el => {
    el.classList.remove('chart_required_active');
  });

  root.querySelectorAll('field-token').forEach(node => {
    if (node.getAttribute('data-field') !== '***') {
      node.classList.remove('chart_required_field');
    }
  });
}

function scrollEditorContainerToNode(editor, domNode)
{
  const container = domNode.closest('.mchat_messages');
  if (!container) return;

  const nodeRect = domNode.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const offset = container.clientHeight * 0.25;

  container.scrollTo({
    top:
      container.scrollTop +
      (nodeRect.top - containerRect.top) -
      offset,
    behavior: 'smooth'
  });
}


function installRequiredOverwriteHandler(editor)
{
  editor.on('transaction', ({ editor, transaction }) => {
    if (!transaction.docChanged) return;

    const sel = editor.state.selection;
    if (!sel.node) return;

    if (
      sel.node.type.name === 'field_token' &&
      sel.node.attrs.field === '***'
    ) {
      // Replace the token with typed content
      editor
        .chain()
        .deleteSelection()
        .run();

      clearResolvedRequired(editor);
      delete editor.view.dom.dataset.requiredIdx;
      ChartEditor.updateNavigationButtons(editor);
    }

  });
}

function getRequiredFieldPositions(editor)
{
  const positions = [];

  editor.state.doc.descendants((node, pos) => {
    if (node.type.name === 'field_token' && node.attrs.field === '***') {
      positions.push(pos);
    }
  });

  return positions;
}


function jumpRequired(editor, direction)
{
  if (!editor) return;

  editor.view.focus();

  var spots = getRequiredSpots(editor);
  if(!spots.length) return;

  var currentIndex = getCurrentRequiredIndex(editor, spots);

  var nextIndex;

  if(direction === 'next')
  {
    nextIndex = (currentIndex === -1) ? 0 : (currentIndex + 1) % spots.length;
  }
  else
  {
    nextIndex = (currentIndex === -1) ? spots.length - 1 : (currentIndex - 1 + spots.length) % spots.length;
  }

  // Persist so the next click knows where we are (avoids cursor-position ambiguity)
  editor.view.dom.dataset.requiredIdx = String(nextIndex);

  var spot = spots[nextIndex];

  // Clear old highlight
  clearResolvedRequired(editor);

  // If it's a field_token node: select node
  if(spot.type === 'field_token')
  {
    highlightAndScroll(editor, spot.from);
    return;
  }

  // If it's plain text "***": select the exact range so typing overwrites it
  editor.commands.setTextSelection({ from: spot.from, to: spot.to });

  // Scroll to selection (use dom at "from")
  var dom = editor.view.domAtPos(spot.from).node;
  if(dom && dom.nodeType === Node.TEXT_NODE) dom = dom.parentNode;

  if(dom)
  {
    dom.classList.add('chart_required_active');
    scrollEditorContainerToNode(editor, dom);
  }
}



function getRequiredSpots(editor)
{
  var spots = [];

  editor.state.doc.descendants(function(node, pos)
  {
    // Case A: field_token node
    if(node.type.name === 'field_token' && node.attrs.field === '***')
    {
      spots.push({
        type: 'field_token',
        from: pos,
        to: pos + node.nodeSize
      });
      return;
    }

    // Case B: plain text "***" inside a text node
    if(node.isText && typeof node.text === 'string')
    {
      var idx = node.text.indexOf('***');
      while(idx !== -1)
      {
        // Text positions are inside the text node, so +1
        var from = pos + 1 + idx;
        var to = from + 3;

        spots.push({
          type: 'text',
          from: from,
          to: to
        });

        idx = node.text.indexOf('***', idx + 3);
      }
    }
  });

  return spots;
}

function getCurrentRequiredIndex(editor, spots)
{
  // Use the index stored by the last jumpRequired call as ground truth.
  // Cursor-position detection is unreliable: an ambiguous cursor position can
  // match the last *** range, causing first-click to skip to the wrong spot.
  var stored = editor.view.dom.dataset.requiredIdx;
  if (stored !== undefined && stored !== '')
  {
    var idx = parseInt(stored, 10);
    if (!isNaN(idx) && idx >= 0 && idx < spots.length)
      return idx;
  }

  return -1;
}

function removeHiddenByDefaultSections(editor) 
{
  const toRemove = []

  editor.state.doc.descendants(node => {
    if (
      node.type.name === 'chart_section' &&
      node.attrs.hidden_by_default === true
    ) {
      toRemove.push(node.attrs.section_type)
    }
  })

  toRemove.forEach(sectionType => {
    removeSection(editor, sectionType)
  })
}



window.jumpRequired = jumpRequired;
